export const OPEN_MARKETPLACE_DISCOUNT_MODAL =
  'open-market-place-discount-modal'
